// src/reducers/BackupCodesReducer.js

const initialState = {
    backupCodes: [],
    isLoading: false,
    error: "",
    rememberDeviceSaved: false,
  };
  
  const BackupCodesReducer = (state = initialState, action) => {
    switch (action.type) {
      case "BACKUP_CODES_LOADING":
        return {
          ...state,
          isLoading: true,
          error: "",
          backupCodes: [],
        };
      case "BACKUP_CODES_SUCCESS":
        return {
          ...state,
          isLoading: false,
          backupCodes: action.payload,
        };
      case "BACKUP_CODES_ERROR":
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      case "BACKUP_REMEMBER_DEVICE_SUCCESS":
        return {
          ...state,
          rememberDeviceSaved: true,
        };
      case "BACKUP_CODES_RESET":
        return initialState;
      default:
        return state;
    }
  };
  
  export default BackupCodesReducer;
  